"use client";

/**
 * Osmani: "Web Vitals 측정 코드 없음 — @vercel/analytics 패키지가 없다"
 * Analytics + Speed Insights 통합 컴포넌트
 *
 * seo1-bot W1 (2026-10-17) — 봇·헤드리스 UA 에서는 두 스크립트를 «싣지 않는다».
 *   봇이 /_vercel/insights/script.js · /_vercel/speed-insights/script.js 를 받아 가고 이벤트를 쏘면
 *   크롤 예산을 먹고 계측이 오염된다. 판정은 lib/seo/bot-rate.ts skipInsightsForUa(명시 목록 — 사람 UA 무영향).
 *   ⚠️ 클라이언트 마운트 뒤 navigator.userAgent 로만 판정한다 — SSR HTML 은 UA 와 무관하게 같다(no-ua-cloaking).
 *   두 컴포넌트는 원래도 마운트 시점에 스크립트를 주입하므로 사람에게 로딩 시점 차이는 없다.
 */

import { useEffect, useState } from "react";
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/next";
import { skipInsightsForUa } from "@/lib/seo/bot-rate";

export function VercelAnalytics() {
  const [enabled, setEnabled] = useState(false);
  useEffect(() => {
    try {
      setEnabled(!skipInsightsForUa(typeof navigator !== "undefined" ? navigator.userAgent : ""));
    } catch {
      setEnabled(true);
    }
  }, []);
  if (!enabled) return null;
  return (
    <>
      <Analytics />
      <SpeedInsights />
    </>
  );
}
